import { useProgress } from '@react-three/drei'
import { useEffect, useState } from 'react'

export default function Loader({ onComplete }) {
    const { progress, active } = useProgress()
    const [displayProgress, setDisplayProgress] = useState(0)
    const [isComplete, setIsComplete] = useState(false)
    const [fadeOut, setFadeOut] = useState(false)

    useEffect(() => {
        if (progress > displayProgress) {
            const timer = setTimeout(() => {
                setDisplayProgress(prev => Math.min(prev + 1, progress))
            }, 15)
            return () => clearTimeout(timer)
        }
    }, [progress, displayProgress])

    useEffect(() => {
        if (!active && displayProgress >= 99 && !isComplete) {
            const timer = setTimeout(() => {
                setDisplayProgress(100)
                setTimeout(() => {
                    setFadeOut(true)
                    setTimeout(() => {
                        setIsComplete(true)
                        onComplete()
                    }, 600)
                }, 400)
            }, 1000)
            return () => clearTimeout(timer)
        }
    }, [active, displayProgress, isComplete, onComplete])

    if (isComplete) return null

    return (
        <div className={`loader-container ${fadeOut ? 'fade-out' : ''}`}>
            <div className="loader-content">
                {/* Progress line */}
                <div className="loader-line">
                    <div
                        className="loader-line-fill"
                        style={{ width: `${displayProgress}%` }}
                    />
                </div>

                {/* Percentage */}
                <div className="loader-percentage">{Math.round(displayProgress)}</div>
            </div>
        </div>
    )
}
